document.addEventListener('DOMContentLoaded', () => {
  const grid = document.getElementById('ajluxe-blog-grid');
  const loadMoreBtn = document.getElementById('load-more-btn');
  const progressFill = document.getElementById('pagination-fill');
  const progressLabel = document.getElementById('pagination-label');

  if (!grid) return;

  const BLOG_HANDLES =
    Array.isArray(window.AJLuxeBlogHandles) && window.AJLuxeBlogHandles.length
      ? window.AJLuxeBlogHandles
      : ['jewelry-guide'];
  const PER_PAGE = 9;
  const FEED_VIEW = 'ajluxe-feed';
  const STRINGS = Object.assign(
    {
      readMore: 'Read more',
      minRead: 'min read',
      showingArticles: 'Showing [shown] of [total] articles',
      noArticles: 'No articles found.',
      loadingError: 'Unable to load articles. Please refresh.',
      loadMore: 'Load more stories',
      loadingMore: 'Loading more stories…',
    },
    window.AJLuxeBlogListingStrings || {}
  );

  let currentPage = 1;
  let articles = [];
  let isLoadingMore = false;
  const feedState = BLOG_HANDLES.reduce((state, handle) => {
    state[handle] = {
      nextPage: 1,
      totalPages: null,
      totalArticles: null,
    };
    return state;
  }, {});

  function escapeHTML(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* Write through the existing text node instead of replacing it: `textContent =`
     is a childList mutation, and Clarity's replay player applies the insert but
     not the remove, so the node replays holding every value it has ever held.
     nodeValue edits replay as one value. Full rationale and the canonical copy
     live in assets/ajluxe-cart-boost.js. */
  function setText(node, value) {
    if (!node) return;
    var first = node.firstChild;
    if (first && first.nodeType === 3 && !first.nextSibling) {
      if (first.nodeValue !== value) first.nodeValue = value;
      return;
    }
    node.textContent = value;
  }

  function interpolate(template, replacements) {
    let output = template;
    Object.keys(replacements).forEach((key) => {
      output = output.replace(`[${key}]`, replacements[key]);
    });
    return output;
  }

  function getTotalArticles() {
    const knownTotals = Object.values(feedState)
      .map((entry) => Number(entry.totalArticles) || 0)
      .filter(Boolean);
    if (!knownTotals.length) return articles.length;
    return knownTotals.reduce((sum, count) => sum + count, 0);
  }

  function hasRemainingFeedPages() {
    return BLOG_HANDLES.some((handle) => {
      const entry = feedState[handle];
      return entry.totalPages === null || entry.nextPage <= entry.totalPages;
    });
  }

  function setLoadMoreLabel(label) {
    if (!loadMoreBtn) return;
    setText(loadMoreBtn, label);
  }

  function setLoadMoreBusy(isBusy) {
    if (!loadMoreBtn) return;
    loadMoreBtn.disabled = isBusy;
    loadMoreBtn.setAttribute('aria-busy', isBusy ? 'true' : 'false');
    setLoadMoreLabel(isBusy ? STRINGS.loadingMore : STRINGS.loadMore);
  }

  function mergeArticles(nextArticles) {
    const merged = articles.concat(nextArticles);
    const seen = new Set();
    const deduped = [];

    for (const article of merged) {
      if (!article || !article.url || seen.has(article.url)) continue;
      seen.add(article.url);
      deduped.push(article);
    }

    deduped.sort((a, b) => b.published_at - a.published_at);
    articles = deduped;
  }

  function buildCard(article, index) {
    const card = document.createElement('article');
    card.className = 'blog-card';
    card.setAttribute('data-index', index);

    const titleEsc = escapeHTML(article.title);
    const excerptEsc = escapeHTML(article.excerpt);
    const tagEsc = escapeHTML(article.tag);
    const urlEsc = escapeHTML(article.url);
    const loading = index < 6 ? 'eager' : 'lazy';
    const imageWidth = Number(article.image_width) || 800;
    const imageHeight = Number(article.image_height) || 600;

    card.innerHTML = `
      <a href="${urlEsc}" class="blog-card__image-wrap">
        ${
          article.image
            ? `<img src="${escapeHTML(article.image)}" alt="${titleEsc}" loading="${loading}" decoding="async" width="${imageWidth}" height="${imageHeight}" sizes="(max-width: 768px) 100vw, 33vw">`
            : `<div class="blog-card__no-image"></div>`
        }
        <span class="blog-card__tag">${tagEsc}</span>
      </a>
      <div class="blog-card__body">
        <div class="blog-card__meta">
          <span>${formatDate(article.published_at)}</span>
          <span class="meta-dot">·</span>
          <span>${Number(article.read_time) || 1} ${escapeHTML(STRINGS.minRead)}</span>
        </div>
        <h2 class="blog-card__title">
          <a href="${urlEsc}">${titleEsc}</a>
        </h2>
        <p class="blog-card__excerpt">${excerptEsc}</p>
        <a href="${urlEsc}" class="blog-card__read-more">
          ${escapeHTML(STRINGS.readMore)} <span aria-hidden="true">→</span>
        </a>
      </div>
    `;
    return card;
  }

  function formatDate(timestamp) {
    return new Date(timestamp * 1000).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  }

  function render(page) {
    const total = getTotalArticles();
    const showing = Math.min(page * PER_PAGE, total);
    const slice = articles.slice(0, showing);

    grid.innerHTML = '';
    slice.forEach((article, i) => {
      grid.appendChild(buildCard(article, i));
    });

    const pct = total > 0 ? (showing / total) * 100 : 0;
    if (progressFill) progressFill.style.width = pct + '%';
    if (progressLabel) {
      progressLabel.textContent = interpolate(STRINGS.showingArticles, {
        shown: String(showing),
        total: String(total),
      });
    }

    if (loadMoreBtn) {
      loadMoreBtn.hidden = showing >= total;
      loadMoreBtn.style.display = showing >= total ? 'none' : 'inline-block';
    }
  }

  async function fetchBlogFeedPage(handle, page) {
    try {
      const res = await fetch(
        `/blogs/${encodeURIComponent(handle)}?view=${FEED_VIEW}&page=${page}`,
        { credentials: 'same-origin' }
      );
      if (!res.ok) return null;
      return JSON.parse(await res.text());
    } catch (err) {
      return null;
    }
  }

  async function loadNextFeedBatch() {
    const handlesToFetch = BLOG_HANDLES.filter((handle) => {
      const entry = feedState[handle];
      return entry.totalPages === null || entry.nextPage <= entry.totalPages;
    });

    if (!handlesToFetch.length) return false;

    const responses = await Promise.all(
      handlesToFetch.map(async (handle) => {
        const entry = feedState[handle];
        const data = await fetchBlogFeedPage(handle, entry.nextPage);
        if (!data || !Array.isArray(data.articles)) return [];

        entry.totalPages = Number(data.total_pages) || 1;
        entry.totalArticles = Number(data.total_articles) || data.articles.length;
        entry.nextPage += 1;
        return data.articles;
      })
    );

    const beforeCount = articles.length;
    mergeArticles([].concat(...responses));
    return articles.length > beforeCount;
  }

  async function ensureArticlesForPage(page) {
    const needed = page * PER_PAGE;
    while (articles.length < needed && hasRemainingFeedPages()) {
      const loadedMore = await loadNextFeedBatch();
      if (!loadedMore) break;
    }
  }

  function showEmpty(message) {
    grid.innerHTML = `<p class="blog-empty">${escapeHTML(message)}</p>`;
    if (progressFill) progressFill.style.width = '0%';
    if (progressLabel) {
      progressLabel.textContent = interpolate(STRINGS.showingArticles, {
        shown: '0',
        total: '0',
      });
    }
    if (loadMoreBtn) {
      loadMoreBtn.hidden = true;
      loadMoreBtn.style.display = 'none';
    }
  }

  if (loadMoreBtn) {
    setLoadMoreLabel(STRINGS.loadMore);
    loadMoreBtn.addEventListener('click', async () => {
      if (isLoadingMore) return;

      const nextPage = currentPage + 1;
      isLoadingMore = true;
      setLoadMoreBusy(true);
      await ensureArticlesForPage(nextPage);
      isLoadingMore = false;
      setLoadMoreBusy(false);

      if (articles.length <= currentPage * PER_PAGE) {
        render(currentPage);
        return;
      }

      currentPage = nextPage;
      render(currentPage);
      const cards = grid.querySelectorAll('.blog-card');
      const firstNew = cards[(currentPage - 1) * PER_PAGE];
      if (firstNew) {
        firstNew.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  ensureArticlesForPage(currentPage)
    .then(() => {
      if (!articles.length) {
        showEmpty(STRINGS.noArticles);
        return;
      }
      render(currentPage);
    })
    .catch(() => {
      showEmpty(STRINGS.loadingError);
    });
});
